// extracted by mini-css-extract-plugin
export default {"logoContainer":"EmailConfirmation_logoContainer__LeLEx","logo":"EmailConfirmation_logo__uoNLR"};